import { addDays } from "date-fns";
import { filter, map } from "rxjs";
import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";

import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import { PaymentPaidAdminParams } from "../interfaces/PaidBackoffice.interface";
import { PaymentPaidAdminSearch } from "./PaymentPaidAdminSearch";
import { PaymentPaidAdminTable } from "./PaymentPaidAdminTable";

export const PaymentPaidAdminResource = () => {
  const params$ = useQueryParams$().pipe(
    filter(() => {
      return window.location.pathname === "/web/admin/facturacion/pagos";
    }),
    map((params: PaymentPaidAdminParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const from_date = getDateAttribute(params.from_date);
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));

      const id_pedidos = getAttributeList(params.id_pedidos);
      const tci_nums = getAttributeList(params.tci_nums);

      const year = params.year || new Date().getFullYear().toString();
      const regimen = params.regimen || "10";
      const num = params.num || "";
      return {
        ...params,
        volante_nums,
        from_date,
        to_date,
        year,
        regimen,
        num,
        id_pedidos,
        tci_nums,
      };
    })
  );
  return (
    <>
      <PaymentPaidAdminSearch params$={params$} />
      <PaymentPaidAdminTable params$={params$} />
    </>
  );
};
